// extracted by mini-css-extract-plugin
export default {"container":"bet-input_container__R5dvb","reversed":"bet-input_reversed__E2yuT"};